module.exports = __webpack_public_path__ + "static/how-it-works-hero-a8028c99bef258b71e88e5f37cb1d166.svg";